import controller from '../../../../Scripts/Controller.js';

/**
 * Purpose: to control styling when in sticky mode.
 */

var selectors = {
    siteHeader: 'header',
    stickyHeader: '.js-sticky-header'
}

function StickyHeaderController() {
    
    function init() {
        var siteHeader = document.querySelector(selectors.siteHeader);
        var stickyHeader = document.querySelector(selectors.stickyHeader);
        if (!stickyHeader) return;

        document.addEventListener('scroll', function () {
            var rect = siteHeader.getBoundingClientRect();
            if (rect.bottom <= 0) {
                stickyHeader.classList.add('is-sticky');
            } else {
                stickyHeader.classList.remove('is-sticky');
            }
        });
    }

    return {
        init: init
    }
}

controller.add('StickyHeaderController', StickyHeaderController);

export default StickyHeaderController;